function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState, useRef, useEffect, Children, cloneElement, FC, Ref } from 'react';
import cn from 'classnames';
import { useAnimation } from '../../../hooks/useAnimation';
import { getAutoHeightDuration } from '../../utils/getAutoHeightDuration';
import { useDrag } from '../../../hooks/useDrag';
import { useForkRef } from '../../../hooks/useForkRef';
require("./Carousel.css");
var styles = {
  "Root": "Carousel-module-Root_Kld",
  "Item": "Carousel-module-Item_3Fb"
};
const noop = _e => {};
const Carousel = ({
  children,
  className,
  controlRef,
  innerRef,
  isSwipeable = true,
  maxLimiter = 0,
  selectedIndex = 0,
  setSelectedIndex = noop,
  slidesToScroll = 1,
  slidesToShow = 1,
  viewportWidth = 340
}) => {
  const rootRef = useRef(null);
  const ownRef = useForkRef(rootRef, innerRef || controlRef);
  const [itemWidth, setItemWidth] = useState(viewportWidth / slidesToShow);
  const [duration, setDuration] = useState(0);
  const _isDragging = useRef(false);
  const _currentShift = useRef(0);
  const [{
    tx
  }, start] = useAnimation({
    tx: 0
  });
  useEffect(() => {
    _currentShift.current = itemWidth * selectedIndex * -1;
    start({
      tx: _currentShift.current
    });
    setDuration(getAutoHeightDuration(itemWidth));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemWidth, selectedIndex, slidesToScroll]);
  useEffect(() => {
    setItemWidth(viewportWidth / slidesToShow);
  }, [viewportWidth, slidesToShow]);
  const draggedUp = mx => {
    const currentFullShift = _currentShift.current + mx;
    const h = currentFullShift > _currentShift.current && Math.abs(_currentShift.current) <= Math.abs(mx) ? 0 : currentFullShift;
    const currentIndex = Math.abs(Math.round(h / itemWidth));

    // возвращаем ячейку на место, если свайп меньше половины ячейки
    if (currentIndex === selectedIndex) {
      start({
        tx: itemWidth * selectedIndex * -1
      });
    }
    if (currentIndex !== selectedIndex) {
      setSelectedIndex(currentIndex);
    }
  };
  const bind = useDrag(({
    event,
    isDragging,
    movement: [mx]
  }) => {
    event?.preventDefault();
    _isDragging.current = isDragging;
    const isBorderLeft = _currentShift.current * -1 - mx <= 0 && Math.sign(mx) === 1;
    if (isDragging) {
      // если крайние слайды, запрещаем их листать

      if (isBorderLeft || Array.isArray(children) && _currentShift.current + mx < itemWidth * maxLimiter * -1 && Math.sign(mx) === -1) {
        return;
      }
      start({
        tx: _currentShift.current + mx
      });
    } else if (mx !== 0) {
      draggedUp(mx);
    }
  });
  if (!Array.isArray(children)) return null;
  return /*#__PURE__*/React.createElement("ul", _extends({
    "aria-atomic": "true",
    "aria-live": "polite",
    className: cn(styles.Root, className),
    ref: ownRef,
    role: "listbox",
    style: {
      transform: `translate3d(${tx}px, 0, 0)`,
      transitionDuration: `${_isDragging.current ? 0 : duration}ms`
    }
  }, isSwipeable ? bind : {}), Children.map(children, (child, i) => {
    const isVisible = i >= Math.floor(selectedIndex) && i < Math.floor(selectedIndex) + Math.ceil(slidesToShow);
    return /*#__PURE__*/React.createElement("li", {
      key: child.key,
      className: styles.Item,
      style: {
        width: itemWidth
      },
      "aria-hidden": !isVisible || undefined
      //@ts-ignore
      ,
      inert: !isVisible ? '' : undefined
    }, /*#__PURE__*/cloneElement(child, {
      ...(Number(selectedIndex) === i && {
        'aria-current': 'true'
      })
    }));
  }));
};
export default Carousel;
if (process.env.NODE_ENV !== 'production') {
  Carousel.displayName = 'Carousel';
}